import App from './App.svelte';
import styles from './main.css';

const app = new App({
	target: document.body,
	props: {
	}
});

export default app;
